import { Controller } from "@hotwired/stimulus";

// Fires a one-shot Fomantic `tada` animation on the "Refer a brand"
// gift icon the first time the user hovers the sidebar — attention
// cue without an infinite animation.
export default class extends Controller {
  connect() {
    this.onHover = this.onHover.bind(this);
    this.element.addEventListener("mouseenter", this.onHover, { once: true });
  }

  disconnect() {
    this.element.removeEventListener("mouseenter", this.onHover);
  }

  onHover() {
    const $ = window.$;
    if (!$) return;
    $(".item.affiliate_dashboard i").transition("tada");
  }
}
